export default __webpack_public_path__ + "static/media/timer.abaf8ace.svg";